import Bloc from './Bloc.js';
import Types from './Types.js';

export default class LoseBlock extends Bloc {

	constructor (src, ctx) {

		super("loseblock", src, ctx, true);
		this.f = (src, ins) => {
			if (ins[0]?.removedFromFight || (ins[0]?.id?.type === "enemy" && ins[0]?.dead && ins[0]?.removed))
				return [];
			ins[0].loseblock(ins[1]);
			return [];
		};
		this.types = [Types.entity, Types.int];
	}
}
